import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '@/components/HomePage.vue'
import CasePage from '@/components/CasePage.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/case/:id',
    name: 'case',
    component: CasePage
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
